import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-credit-history',
  templateUrl: './credit-history.component.html',
  styleUrls: ['./credit-history.component.css']
})
export class CreditHistoryComponent implements OnInit {

  creditData: any;
  userId: string;
  page = 1;
  perPage = 20;
  isLoading = false;

  get lower() {
    return this.perPage * (this.page - 1) + 1;
  }

  get upper() {
    return Math.min(this.perPage * this.page, this.creditData.count);
  }

  constructor(
    private userService: UserService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.userId = params.userId;
  
      this.loadCreditsHistory();
    });
  }

  loadCreditsHistory() {
    this.isLoading = true;

    this.userService.getCreditsHistory(this.userId, this.page, this.perPage)
      .subscribe(
        res => {
          this.creditData = res;
          this.creditData.results.forEach(data => data.status = data.credits < 0 ? 'out' : 'in');
          this.isLoading = false;
        },
        err => {
          this.isLoading = false;
        } 
      );
  }

  jumpToPage(event: any) {
    this.page = event;
    this.loadCreditsHistory();
  }
}
